import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Flame } from "lucide-react";

/**
 * StreakBadge - small pill in topbar showing daily login streak.
 * On mount: POST /me/ping (idempotent), then GET /me/streak.
 */
export const StreakBadge = ({ apiUrl, lang = "ms" }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const isEn = lang === "en";

  const refresh = useCallback(async () => {
    try {
      // Heartbeat first (idempotent per day), then fetch
      await axios.post(`${apiUrl}/me/ping`, {});
      const res = await axios.get(`${apiUrl}/me/streak`);
      setData(res.data);
    } catch {
      // Silent - feature is non-critical
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => { refresh(); }, [refresh]);

  if (loading || !data) return null;

  const streak = data.streak || 0;
  const isActive = data.active_today;

  // Don't render if streak is 0 to avoid clutter for inactive users
  if (streak === 0) return null;

  return (
    <div
      className={`hidden sm:inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold transition-all ${
        isActive
          ? "bg-orange-50 text-orange-600 ring-1 ring-orange-100"
          : "bg-slate-50 text-slate-400"
      }`}
      data-testid="streak-badge"
      title={
        isEn
          ? `${streak} day${streak > 1 ? "s" : ""} streak${data.longest_streak ? ` (best: ${data.longest_streak})` : ""}`
          : `${streak} hari berturut-turut${data.longest_streak ? ` (terbaik: ${data.longest_streak})` : ""}`
      }
    >
      <Flame size={12} className={isActive ? "text-orange-500" : "text-slate-300"} fill={isActive ? "currentColor" : "none"} />
      <span data-testid="streak-count">{streak}</span>
    </div>
  );
};

export default StreakBadge;
